"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var GamblingLimits_1 = require("../../../GamblingLimits");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TopupButton = function (_a) {
    var currency = _a.currency, amount = _a.amount, minDepositAmount = _a.minDepositAmount, isSubmitting = _a.isSubmitting, isSubmitButtonDisabled = _a.isSubmitButtonDisabled, handleClickSubmitBtn = _a.handleClickSubmitBtn, isRequiredFieldsEmpty = _a.isRequiredFieldsEmpty;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var data = (0, swr_hooks_1.useDepositLimit)().data;
    var _b = (0, react_1.useState)(false), isShowDepositLimitAlmostReached = _b[0], setShowDepositLimitAlmostReached = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        data &&
            !(data === null || data === void 0 ? void 0 : data.reached) &&
            ((data === null || data === void 0 ? void 0 : data.currentValue) || (data === null || data === void 0 ? void 0 : data.currentValue) === 0) &&
            Number(amount) > Number(data === null || data === void 0 ? void 0 : data.maxValue) - Number(data === null || data === void 0 ? void 0 : data.currentValue) &&
            isShowDepositLimitAlmostReached && (react_1.default.createElement(GamblingLimits_1.DepositLimitAlmostReachedNotification, { onCloseHandler: function () {
                setShowDepositLimitAlmostReached(false);
            } })),
        react_1.default.createElement("div", { style: { marginTop: '6px' } },
            react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", color: "primary", text: "upper", height: "44px", loading: isSubmitting, maxWidth: "100%", onClick: function () {
                    if (isRequiredFieldsEmpty) {
                        var el = document === null || document === void 0 ? void 0 : document.getElementById('deposit-fields');
                        el === null || el === void 0 ? void 0 : el.scrollIntoView({
                            block: 'start',
                            inline: 'nearest',
                            behavior: 'smooth',
                        });
                        return;
                    }
                    setShowDepositLimitAlmostReached(true);
                    handleClickSubmitBtn === null || handleClickSubmitBtn === void 0 ? void 0 : handleClickSubmitBtn();
                }, className: "".concat(styles_module_scss_1.default.container), disabled: isSubmitButtonDisabled },
                t('toppingUpWith'),
                " ", "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat(amount || '')))));
};
exports.default = TopupButton;
